import(/* webpackMode: "eager" */ "/opt/gdocnext_dev2/app/template.tsx");
